import React, { useState } from 'react';
import QuaTrinhLaySoLieu from './QuaTrinhLaySoLieu';
import KiemTraSoLieu from './KiemTraSoLieu';
import DuyetKiemTraSoLieu from './DuyetKiemTraSoLieu';

const SoLieuNghienCuuTab = ({ hoSoId, isAdmin, isRestricted }) => {
    const [activeTab, setActiveTab] = useState('quaTrinhLaySoLieu');

    if (activeTab === 'kiemTraSoLieu') {
        if (isAdmin) {
            return <DuyetKiemTraSoLieu hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} />;
        }
        return <KiemTraSoLieu hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} isRestricted={isRestricted} />;
    }
    
    return <QuaTrinhLaySoLieu hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} isAdmin={isAdmin} isRestricted={isRestricted} />;
};

export default SoLieuNghienCuuTab;
